import React from "react";
import "./Modal.css";

function Modal({ isOpen, title, message, onClose, onConfirm, isProcessing, responseMessage }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          {message && <p>{message}</p>}
          
          {responseMessage && (
            <div className={`response-message ${responseMessage.type}`}>
              {responseMessage.text}
            </div>
          )}
        </div>
        <div className="modal-footer">
          {!responseMessage && (
            <>
              <button 
                className="btn secondary-btn" 
                onClick={onClose}
                disabled={isProcessing}
              >
                Cancel
              </button>
              <button 
                className="btn danger-btn" 
                onClick={onConfirm}
                disabled={isProcessing}
              >
                {isProcessing ? "Processing..." : "Yes, Reset Data"}
              </button>
            </>
          )}
          
          {responseMessage && (
            <button className="btn primary-btn" onClick={onClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;